export default function PHP_ReferenceOutputControl() {
  return (
    <div>
      <h1>PHP_ReferenceOutputControl</h1>
    </div>
  );
}
